const PREFIX = '[proctoring]'

export const logProctoring = (step: string, detail?: unknown) => {
    if (detail === undefined) {
        console.info(PREFIX, step)
        return
    }
    console.info(PREFIX, step, detail)
}

export const warnProctoring = (step: string, detail?: unknown) => {
    if (detail === undefined) {
        console.warn(PREFIX, step)
        return
    }
    console.warn(PREFIX, step, detail)
}

export const errorProctoring = (step: string, detail?: unknown) => {
    if (detail === undefined) {
        console.error(PREFIX, step)
        return
    }
    console.error(PREFIX, step, detail)
}
